import { FC, useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material'
import { PrognoseSetResponse } from '../../types/apiRequests'

interface EditPrognoseDialogProps {
  open: boolean
  onClose: () => void
  onSave: (data: { naam: string; omschrijving: string; publicatie_status: string }) => void
  record: PrognoseSetResponse
}

const PUBLICATIE_STATUS_OPTIONS = [
  { value: 'concept', label: 'Concept' },
  { value: 'definitief', label: 'Definitief' },
  { value: 'archief', label: 'Archief' },
]

const EditPrognoseDialog: FC<EditPrognoseDialogProps> = ({
  open,
  onClose,
  onSave,
  record,
}) => {
  const [naam, setNaam] = useState(record.naam)
  const [omschrijving, setOmschrijving] = useState(record.omschrijving || '')
  const [publicatieStatus, setPublicatieStatus] = useState(
    record.publicatie_status || 'concept'
  )

  useEffect(() => {
    setNaam(record.naam)
    setOmschrijving(record.omschrijving || '')
    setPublicatieStatus(record.publicatie_status || 'concept')
  }, [record])

  const handleSave = () => {
    onSave({
      naam,
      omschrijving,
      publicatie_status: publicatieStatus,
    })
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Prognose bewerken</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Naam"
            value={naam}
            onChange={(e) => setNaam(e.target.value)}
            fullWidth
            required
          />
          <TextField
            label="Omschrijving"
            value={omschrijving}
            onChange={(e) => setOmschrijving(e.target.value)}
            fullWidth
            multiline
            rows={3}
          />
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={publicatieStatus}
              label="Status"
              onChange={(e) => setPublicatieStatus(e.target.value)}
            >
              {PUBLICATIE_STATUS_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuleren</Button>
        <Button onClick={handleSave} variant="contained" disabled={!naam.trim()}>
          Opslaan
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditPrognoseDialog
